import React from 'react'
import TopBreadcrumb from 'components/TopBreadCrumb'
import AbnormalPage from '../../Exam/AbnormalPage/AbnormalPage'

const Page = () => {
  const breadcrumbList = [{ name: '考核' }, { name: '剔除时段' }]
  return (
    <div
      style={{ height: '100%', display: 'flex', flexDirection: 'column', padding: '0 24px 24px' }}
    >
      <TopBreadcrumb breadcrumbList={breadcrumbList} />
      <AbnormalPage customStyle={{ padding: 0 }} />
    </div>
  )
}

export default Page
